import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import Image from '../../BaseComponents/Image'
import BasicText from '../../Theme/Fonts/BasicText'
import { ProfileProps } from '..'

const LabelInfo: FC<ProfileProps['labelProps']> = ({ text, imageUrl, alt, href, onPress }) => (
    <Touchable href={href} onPress={onPress}>
        <Grid noExpand horizontal center>
            {imageUrl ? (
                <Image size="L" imageUrl={imageUrl} alt={alt} aspectRatio="1:1" width={16} />
            ) : null}
            <BasicText
                fontSize={['FS11', 'FS11', 'FS14']}
                lineHeight={['LH14', 'LH14', 'LH16']}
                numberOfLines={2}
                paddingLeft={imageUrl ? 2 : 0}
                textAlign="center"
                color="onyx-4"
            >
                {text}
            </BasicText>
        </Grid>
    </Touchable>
)

export default LabelInfo
